import { Button, Container, Icon } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ErrorDetailContainer } from "../../../api/config";
import { FolderDto, FolderService } from "../../../api/psc";
import {
    ConfirmationDialog,
    EmptyListMessage,
    PageHeader,
    Spinner,
} from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import { SnackbarContext } from "../../../contexts/SnackbarContext";
import FolderItem from "../components/FolderItem";
import UpsertFolder from "../dialogs/UpsertFolder";

export default function Folders() {
    const { openDialog } = useContext(DialogContext);
    const { showSnackbar } = useContext(SnackbarContext);

    const [folders, setFolders] = useState<FolderDto[] | null>(null);

    useEffect(() => {
        fetchFolders();
    }, []);

    const fetchFolders = () => {
        setFolders(null);
        FolderService.getAllFolders("1").then((r) => {
            setFolders(r);
        });
    };

    const openDeleteFolderDialog = (folder: FolderDto) => {
        openDialog(
            <ConfirmationDialog
                title="آیا نسبت به حذف این پوشه اطمینان دارید؟"
                onAccept={() => deleteFolder(folder)}
            />
        );
    };

    const deleteFolder = (folder: FolderDto) => {
        FolderService.deleteFolder(folder.id, "1")
            .then((r) => {
                fetchFolders();
            })
            .catch((e: ErrorDetailContainer) => {
                showSnackbar(e.getFirstError(), "error");
            });
    };

    const openCreateOrUpdateFolderDialog = (folder?: FolderDto) => {
        openDialog(<UpsertFolder folder={folder} />, () => {
            fetchFolders();
        });
    };

    if (!folders) {
        return <Spinner />;
    }

    return (
        <Container maxWidth="sm">
            <PageHeader
                title="لیست پوشه ها"
                action={
                    <Button
                        onClick={() => openCreateOrUpdateFolderDialog()}
                        variant="contained"
                        endIcon={<Icon>add</Icon>}
                    >
                        افزودن پوشه
                    </Button>
                }
            />

            {folders.length === 0 && (
                <EmptyListMessage message="پوشه ای یافت نشد" />
            )}

            {folders.map((u) => (
                <FolderItem
                    onDelete={openDeleteFolderDialog}
                    onEdit={openCreateOrUpdateFolderDialog}
                    key={u.id}
                    folder={u}
                />
            ))}
        </Container>
    );
}
